import React, { useState, useEffect } from "react";
import cssLogin from "../common.module.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomImageContainer from "../../../components/common/CustomImageContainer.jsx";
import SignUpImg from "../../../assets/SignUpImg.svg";
// import Starfor from "../../../assets/StarForLogo.svg";
import AtmanirbharLogo from "../../../assets/AtmanirbharFinsLogo2026.jpg";
import Text from "../../../components/typography/Text/index.jsx";
import { errorToast, successToast, warnToast } from "../../../utils/toasts.jsx";
import { Link, useNavigate } from "react-router-dom";
import Grid from "../../../components/layout/grid/Grid";
import CustomTextInput from "../../../components/common/CustomTextInput";
import { EyeIcon } from "hugeicons-react";
import CustomButton from "../../../components/common/CustomButton/CustomButton";
import { EyeSlashIcon } from "@heroicons/react/16/solid";
import { MdEmail, MdLock, MdSms } from "react-icons/md";
import { IconContext } from "react-icons/lib";
import { AuthService } from "../../../Services/loginService.js";
import { useDispatch, useSelector } from "react-redux";
import { setTokens, setUserData } from "../../../Redux Store/Slices/auth.js";

function Login({ isSuperAdmin = false }) {
  const ctx = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [geoPermissionState, setGeoPermissionState] = useState(null);
  const navigate = useNavigate();
  const [location, setLocation] = useState({ lat: 0, long: 0 });

  const loginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Required"),
    password: Yup.string().min(4, "Too Short!").required("Required"),
  });

  const OnSubmitOld = async (values, { setSubmitting, setErrors }) => {
    const data = {
      email: values.email,
      password: values.password,
    };
    try {
      const response = await AuthService.login(data);
      if (response.data.success === true) {
        successToast("Login Successful!");
        const data = response?.data?.data;
        const tokens = response?.data?.token;
        dispatch(setTokens(tokens));

        dispatch(setUserData(data));
        navigate("/");
      } else {
        const apiError = response.data.error;
        if (Array.isArray(apiError)) {
          apiError.forEach((err) => {
            if (err.path === "password") {
              setErrors(err.msg);
            } else if (err.path === "email") {
              setErrors(err.msg);
            }
          });
        } else {
          errorToast(response.data.error.message);
        }
      }
    } catch (err) {
      const apiError = err.response.error;
      if (Array.isArray(apiError)) {
        apiError.forEach((err) => {
          if (err.path === "password") {
            setErrors(err.msg);
          } else if (err.path === "email") {
            setErrors(err.msg);
          }
        });
      } else {
        errorToast(err.response.data?.error?.[0]?.msg);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const OnSubmit = async (values, setSubmitting, setErrors, setFieldError) => {
    Promise.allSettled([
      AuthService.adminLogin(values.email, values.password),
      AuthService.relationshipManagerLogin(values.email, values.password),
    ]).then((responses) => {
      console.log("All -> ", responses);
      if (responses[0].status === "fulfilled" && responses[1].status === "fulfilled") {
        //TODO: to chose the login type
      } else if (responses[0].status === "fulfilled" && responses[0].value?.data?.success) {
        //* Admin
        const data = responses[0].value?.data?.data;
        const tokens = responses[0].value?.data?.token;

        dispatch(setTokens(tokens));
        dispatch(setUserData(data));
        
        successToast("Login Successful!");
        navigate("/");
      } else if (responses[1].status === "fulfilled" && responses[1].value?.data?.success) {
        //* Relationship Manager
        const data = responses[1].value?.data?.data;
        const tokens = responses[1].value?.data?.token;

        dispatch(setTokens(tokens));
        dispatch(setUserData(data));
        
        successToast("Login Successful!");
        navigate("/");
      } else {
        setErrors({
          email: "Invalid email or password",
          password: "Invalid email or password",
        });
      }
    }).catch((error) => {
      console.log("Error -> ", error);
    }).finally(() => {
      setSubmitting(false);
    })
  };

  return (
    <section className=" w-full h-screen flex flex-1 bg-white">
      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <div className={cssLogin.cardwidth}>
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8 flex flex-col items-center justify-center w-[100%]">
              <div className="flex gap-6">
                <div className="flex flex-col items-center justify-center">
                  <div className="flex justify-center items-center h-full w-full mb-2">
                    <CustomImageContainer
                      src={AtmanirbharLogo}
                      height={"5rem"}
                    />
                  </div>

                  <Text variant="h3-title" className="mt-0">
                    Login into your account{" "}
                  </Text>
                </div>
              </div>
              <div className=" w-full">
                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                  }}
                  validationSchema={loginSchema}
                  onSubmit={ (values, { setSubmitting, setErrors, setFieldError }) => {
                    OnSubmit (values,setSubmitting, setErrors, setFieldError )
                  }}
                >
                  {({ isValid, isSubmitting }) => (
                    <Form>
                      <Grid xs={12} md={12}>
                        <Grid item xs={12} md={12}>
                          <CustomTextInput
                            name={"email"}
                            label={"Email"}
                            placeholder={"enter your email"}
                            endIconBg={true}
                            endIcon={<MdEmail />}
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <CustomTextInput
                            name={"password"}
                            label={"Password"}
                            endIconBg={true}
                            type={isPasswordShow ? "text" : "password"}
                            placeholder={"enter your password"}
                            endIcon={
                              isPasswordShow ? <EyeIcon /> : <EyeSlashIcon />
                            }
                            onEndIconClick={() =>
                              setIsPasswordShow((prev) => !prev)
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <div
                            className="text-blue-800"
                            style={{ cursor: "pointer", textAlign: "right" }}
                            onClick={() => {
                              navigate("/forgot-password");
                            }}
                          >
                            Forgot Password?
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <CustomButton
                            style={{
                              width: "100%",
                            }}
                            label={"Log in"}
                            size={"md"}
                            type={"submit"}
                            isLoading={isSubmitting}
                            disabled={!isValid || isSubmitting}
                            // onClick={() => {navigate('/leads');
                            // }}
                          />
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center  mx-auto md:h-screen lg:py-0 bg-white w-full">
          <CustomImageContainer src={SignUpImg} width={"70%"} height={"70%"} />
        </div>
      </div>
    </section>
  );
}

export default Login;
